import axiosFlow from '@/services/axios/axiosFlow'
import { isNullOrUndefined } from '@/utils/functions'

export default class PausasService {
  static async get(ativo) {
    const params = new URLSearchParams()

    if (!isNullOrUndefined(ativo)) {
      params.append('Ativo', ativo)
    }

    return axiosFlow.get(`pausas?${params}`).then(res => res.data.data)
  }

  static async getById(pausaId) {
    return axiosFlow.get(`pausas/${pausaId}`).then(res => res.data.data)
  }

  static async getSituacaoAtual() {
    return axiosFlow.get('pausas/situacao-atual').then(res => res.data.data)
  }

  static async criar(body) {
    return axiosFlow.post('pausas', body)
  }

  static async atualizar(pausaId, body) {
    return axiosFlow.put(`pausas/${pausaId}`, body)
  }

  static async ativarOuInativarPausa(pausaId, body) {
    return axiosFlow.put(`pausas/${pausaId}/ativada`, body)
  }

  static async salvarRegistroPausaAgente(pausaId, body) {
    const params = new URLSearchParams()

    if (pausaId) {
      params.append('PausaId', pausaId)
    }

    return axiosFlow.put(`pausas/entrada-saida?${params}`, body)
  }
}
